import SliderCatalog from './SliderCatalog'

export default SliderCatalog
